import React, { Component } from "react";

// Components
import PhoneField from "../../../utils/PhoneField";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

class AssistantExecFieldset extends Component {
	constructor(props) {
		super(props);

		this.dataProps = [
			"assistant_exec_fname",
			"assistant_exec_lname",
			"assistant_exec_title",
			"assistant_exec_email",
			"assistant_exec_phone",
			"assistant_exec_phone_extension"
		];
		this.miscProps = ["errors", "inProcess"];
	}

	shouldComponentUpdate(nextProps) {
		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	render() {
		const { data, errors, inProcess } = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Assistant Executive</div>

				<div className="fieldset-indent">
					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Assistant Executive First Name:</label>

							{!!errors.assistant_exec_fname && (
								<ErrorWrap animate={1}>{errors.assistant_exec_fname}</ErrorWrap>
							)}
							<input
								type="text"
								id="assistant_exec_fname"
								value={data.assistant_exec_fname}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>

						<div className="form-field half-field">
							<label>Assistant Executive Last Name:</label>

							{!!errors.assistant_exec_lname && (
								<ErrorWrap animate={1}>{errors.assistant_exec_lname}</ErrorWrap>
							)}
							<input
								type="text"
								id="assistant_exec_lname"
								value={data.assistant_exec_lname}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
					</div>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Assistant Executive Title:</label>

							{!!errors.assistant_exec_title && (
								<ErrorWrap animate={1}>{errors.assistant_exec_title}</ErrorWrap>
							)}
							<input
								type="text"
								id="assistant_exec_title"
								value={data.assistant_exec_title}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
						<div className="form-field half-field">
							<label>Assistant Executive Email</label>

							{!!errors.assistant_exec_email && (
								<ErrorWrap animate={1}>{errors.assistant_exec_email}</ErrorWrap>
							)}
							<input
								type="email"
								id="assistant_exec_email"
								value={data.assistant_exec_email}
								// maxLength="9"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={event => this.props.handleInputChange(event)}
							/>
						</div>
					</div>

					<div className="floated-field-container">
						<PhoneField
							label={"Assistant Executive Phone"}
							phone_name="assistant_exec_phone"
							ext_name="assistant_exec_phone_extension"
							phone={data.assistant_exec_phone}
							extension={data.assistant_exec_phone_extension}
							errorPhone={errors.assistant_exec_phone}
							errorExtension={errors.assistant_exec_phone_extension}
							inProcess={inProcess}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default AssistantExecFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/organizations/form-components/AssistantExecFieldset.js